"use client";

import { useLayoutEffect, useRef } from "react";
import { dimmerFlaechen, type Bildschirm, type Rechteck } from "./tour-position";

/*
 * Dimmer des Tour-Overlays (Musterkatalog M-017, Design-Guide `tour-overlay.md`).
 *
 * Mit Ziel: vier feste Dimm-Flächen um ein Loch (oben, unten, links, rechts) plus ein Rahmen-Ring am Loch. Die Fläche IM Loch
 * ist unbedeckt, das Ziel bleibt bedienbar; kein `box-shadow` mit riesigem Streuradius (Arbitrary Value). Ohne Ziel (Zentral-Karte)
 * eine Vollfläche mit Blur wie der Hintergrund des Kleinen Modals (Abweichung AW-008). Im Zustand „Ziel nicht gefunden“ rendert
 * das Overlay gar keinen Dimmer (nicht-modaler Hinweis, die Seite bleibt bedienbar).
 * Maße und Lage setzt dieser Baustein zur Laufzeit am Element (wie `dropdown-menue.tsx`); sie sind Koordinaten, keine Gestaltung.
 */

const FLAECHE = "fixed top-0 start-0 z-90 bg-foreground/50";
const RING = "fixed top-0 start-0 z-90 rounded-xl ring-2 ring-primary pointer-events-none motion-reduce:transition-none";

function setze(el: HTMLElement | null, r: Rechteck) {
  if (!el) return;
  el.style.left = `${Math.round(r.links)}px`;
  el.style.top = `${Math.round(r.oben)}px`;
  el.style.width = `${Math.round(r.breite)}px`;
  el.style.height = `${Math.round(r.hoehe)}px`;
}

export function TourDimmer({ loch, bildschirm }: { loch: Rechteck | null; bildschirm: Bildschirm }) {
  const flaechen = useRef<Array<HTMLDivElement | null>>([]);
  const ring = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!loch) return;
    dimmerFlaechen(loch, bildschirm).forEach((r, i) => setze(flaechen.current[i] ?? null, r));
    setze(ring.current, loch);
  }, [loch, bildschirm]);

  if (!loch) {
    return (
      <>
        {/* Preline: component/modal/modal-default (Hintergrundfläche) */}
        {/* Abweichung AW-008: Blur wie der Hintergrund des Kleinen Modals (Präzedenz) */}
        <div className="fixed inset-0 z-90 bg-foreground/50 backdrop-blur-md" aria-hidden="true" data-tour-dimmer="voll" />
      </>
    );
  }
  return (
    <>
      {/* Preline: component/modal/modal-default (Hintergrundfläche, vier Flächen um das Ziel-Loch) */}
      {[0, 1, 2, 3].map((i) => (
        <div
          key={i}
          ref={(el) => {
            flaechen.current[i] = el;
          }}
          className={FLAECHE}
          aria-hidden="true"
          data-tour-dimmer="flaeche"
        />
      ))}
      <div ref={ring} className={RING} aria-hidden="true" data-tour-dimmer="ring" />
    </>
  );
}
